import { CouponAward, LiveLotteryItem } from "@/models/reward";
import { useCommonContext } from "@/utils/context/common";
import { getCurrentformatTime } from "@/utils/date-format";
import React from "react";
import styles from "./LiveLottery.module.less";

interface CardProps {
  lottery?: LiveLotteryItem;
  onAddressAction?: (lottery?: LiveLotteryItem) => void;
}

const LiveLottery: React.FC<CardProps> = ({ lottery, onAddressAction }) => {
  const content = () => {
    return (
      <>
        <div className={styles.shop_title}>
          <div className={styles.title_left}>{lottery?.lotteryType}</div>
        </div>
        <div className={`${styles.content_title} ${styles.content_bottom}`}>
          {`${lottery?.awardName}`}
        </div>
        {lottery?.claimDeadline && (
          <div
            className={`${styles.content_desc} ${styles.content_bottom}`}>{`有效期至：${lottery?.claimDeadline}`}</div>
        )}
      </>
    );
  };

  const bottomRight = () => {
    return (
      <div className={styles.right_forward} onClick={() => onAddressAction?.(lottery)}>
        <div className={styles.btn_title}>填写地址</div>
      </div>
    );
  };

  const lotteryResult = () => {
    // lotteryResult 0 未中奖 1 中奖 2 取消
    // addressStatus 0 已填写 1 未填写 2 过期
    const { lotteryResult = 0, addressStatus = 0 } = lottery || {};
    let txt = "已过期";
    let status = 3; // 0 未中奖 1 中奖 2 取消 3 已过期
    if (lotteryResult === 0) {
      txt = "未中奖";
      status = -1;
    }
    if (lotteryResult === 1) {
      if (addressStatus === 2) {
        txt = "已过期";
        status = 2;
      } else if (addressStatus === 1) {
        txt = "待领取";
        status = 1;
      } else {
        txt = "已领取";
        status = 0;
      }
    }
    return { txt, status };
  };

  return (
    <>
      <div className={styles.container}>
        <div className={styles.top}>
          <div>{`中奖时间：${lottery?.lotteryTime}`}</div>
          <div
            className={`${styles.lotteryResultTag} ${styles["lotteryResultTag" + lotteryResult().status]}`}>
            {lotteryResult().txt}
          </div>
        </div>
        <div className={styles.card}>
          <div className={styles.card_left}>
            <img
              className={styles.left_image}
              src={
                lottery?.awardPic ||
                "https://akim-oss.aikucun.com/7dfa1c407b39f966c00dd3a19fff110becf26a1a_1762253710220_53.png"
              }
            />
            <div className={styles.left_content}>{content()}</div>
          </div>
        </div>
        {lotteryResult().status === 1 && (
          <>
            <img
              className={styles.bottomLine}
              src={
                "https://akim-oss.aikucun.com/mshop/7056538220bfea98f51bfaee99f70b7d2423d7db_1723120200611_89.png"
              }
            />
            <div className={`${styles.bottom} ${styles.bottom_end}`}>
              <div className={styles.bottom_right}>{bottomRight()}</div>
            </div>
          </>
        )}
        {lotteryResult().status === 0 && lottery?.shippingAddress && (
          <>
            <img
              className={styles.bottomLine}
              src={
                "https://akim-oss.aikucun.com/mshop/7056538220bfea98f51bfaee99f70b7d2423d7db_1723120200611_89.png"
              }
            />
            <div className={`${styles.bottom}`}>
              <div className={`${styles.bottom_right} ${styles.bottom_right_address}`}>
                收货地址：{lottery?.shippingAddress}
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default LiveLottery;
